<template>
    <button
        role="tab"
        :aria-selected="isActive"
        class="tab-button"
        :class="[`size-${size}`, { active: isActive }]"
        :title="title"
        @click="handleButtonClick"
    >
        <slot>
            {{ title }}
        </slot>
    </button>
</template>

<script lang="ts">
    import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

    @Component({
        components: {},
    })
    export default class TabButton extends Vue {
        @Prop({ type: String }) public title!: string;
        @Prop({ type: String, default: 'normal' }) public size!: 'normal' | 'large';
        @Prop({ default: false, type: Boolean }) public isActive!: boolean;

        @Emit('click')
        public handleButtonClick() {
            return;
        }
    }
</script>

<style lang="less" scoped>
    .tab-button {
        height: 40px;
        padding: 0 @spacing-16;
        overflow: hidden;
        color: @info-color;
        font-family: @default-font-family;
        white-space: nowrap;
        text-overflow: ellipsis;
        background-color: transparent;
        border: none;
        border-radius: @border-radius-6;
        cursor: pointer;
        .h5();
        .generic-transition(~'color');

        &.size-large {
            height: 56px;
        }

        &:hover {
            color: @primary-color;
        }

        &.active {
            color: @primary-color;
            background-color: @primary-color-8;
        }

        &:focus,
        &:active {
            outline: none;
        }
    }
</style>
